/* Company Confidential, Copyright (c) 2021 Signant Health, Ltd. All Rights Reserved. */

import { FormControl, MenuItem, TextField } from '@material-ui/core';
import React from 'react';
import { useIntl } from 'react-intl';
import { DROPDOWN_OPTIONS, REQUIRED_FIELDS } from '../consts';
import { LightTooltip } from './Tooltip';

export default function Dropdown({ values, errors, field, sites, roles, onChange }) {
  const { formatMessage } = useIntl();
  let options;
  switch (field) {
    case 'priority':
      options = DROPDOWN_OPTIONS.prioFields;
      break;
    case 'site':
      options = sites || [];
      break;
    case 'userChangeType':
      options = DROPDOWN_OPTIONS.userChangeTypes;
      break;
    case 'userType':
      options = DROPDOWN_OPTIONS.userTypes;
      break;
    case 'userRole':
      options = roles || [];
      break;
    default:
      options = DROPDOWN_OPTIONS.patientFields;
      break;
  }

  const inputLabelId = `${field}label`;
  const isRequired = REQUIRED_FIELDS.all.includes(field) || REQUIRED_FIELDS.UCF.includes(field);

  return (
    <div key={field} className="input-container">
      <FormControl variant="outlined" fullWidth margin="normal" required={isRequired}>
        <LightTooltip
          title={<span style={{ fontSize: '12px' }}>{formatMessage({ id: `general.${field}` })}</span>}
          placement="right-end"
        >
          <TextField
            error={!!errors[field]}
            labelid={inputLabelId}
            variant="outlined"
            id={field}
            name={field}
            onChange={onChange}
            value={values[field] || 'none'}
            label={`${formatMessage({ id: `form.${field}` })} *`}
            select
          >
            <MenuItem key="placeholder" disabled value="none">
              <div className="placeholder-menuitem">{`${formatMessage({ id: 'form.select' })} ${formatMessage({
                id: `form.${field}`
              })}`}</div>
            </MenuItem>
            {options.map((option, index) => {
              let label = '';
              if (field === 'userRole') {
                if (values.userType && option.type) {
                  if (values.userType.toLowerCase() === option.type.toLowerCase()) {
                    label = option.name;
                    return (
                      <MenuItem key={`${index}-${option.name}`} value={label}>
                        {label}
                      </MenuItem>
                    );
                  }
                }
                return null;
              }
              if (field === 'site') {
                label = option;
              } else {
                label = formatMessage({ id: `form.${option}` });
              }
              return (
                <MenuItem key={`${field}-${index}`} value={label}>
                  {label}
                </MenuItem>
              );
            })}
          </TextField>
        </LightTooltip>
      </FormControl>
    </div>
  );
}
